export const CODE_COLORS = {
  grey: '#CCCCCC',
  red: '#FF7070',
  orange: '#FEB267',
  green: '#7DBA8A',
  blue: '#4A90E2',
  purple: '#C584CC'
};

export const CODE_TAG_BACKGROUND_COLORS = {
  grey: '#ECECEC',
  red: '#FFC3C3',
  orange: '#FFDDBB',
  green: '#D1F2D8',
  blue: '#BED8FF',
  purple: '#FBD2FF'
};